module.exports = __webpack_public_path__ + "media/paper_rip.36e3e774.mp4";